function Pager(context, limit, opt_offset) {
    this.context = context;
    this.limit = Math.min(limit, 100);
    this.offset = Math.max(opt_offset || 0, 0);
    this.total = 0;
    this.count = 0;
    this.currentPage = 0;
    this.totalPages = 0;
}

Pager.prototype.update = function(data, response) {
    this.offset = _.toInteger(response.headers['x-offset']);
    this.total = _.toInteger(response.headers['x-total']);
    this.currentPage = _.toInteger(response.headers['x-current-page']);
    this.totalPages = _.toInteger(response.headers['x-total-pages']);
    this.count = data.length;
};

Pager.prototype.first = function() {
    return {
        offset: 0,
        limit: this.limit
    };
};

Pager.prototype.current = function() {
    return {
        offset: this.offset,
        limit: this.limit
    };
};

Pager.prototype.hasPrev = function() {
    return this.offset > 0;
};

Pager.prototype.prev = function() {
    return {
        offset: Math.max(0, this.offset - this.limit),
        limit: this.limit
    };
};

Pager.prototype.hasNext = function() {
    return this.offset + this.limit < this.total;
};

Pager.prototype.next = function() {
    return {
        offset: this.offset + this.limit,
        limit: this.limit
    };
};

export default Pager;
